import { render, staticRenderFns } from "./DefinitionsSection.vue?vue&type=template&id=ecde2072&scoped=true"
import script from "./DefinitionsSection.vue?vue&type=script&lang=js"
export * from "./DefinitionsSection.vue?vue&type=script&lang=js"
import style0 from "./DefinitionsSection.vue?vue&type=style&index=0&id=ecde2072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde2072",
  null
  
)

export default component.exports